import React from 'react';
import Tabs from '../../../../components/Tabs';
import OrderDetailInfo from '../OrderDetailInfo';
import OrderCancelHistory from '../OrderCancelHistory';
import OrderReturnHistory from '../OrderReturnHistory';
import OrderExchangeHistory from '../OrderExchangeHistory';
import ReviewDetailInfo from '../OrderReviewInfo';
import OrderBalanceInfo from '../OrderBalanceInfo';
import OrderInquiryInfo from '../OrderInquiryInfo';
import OrderQnaInfo from '../OrderQnaInfo';
import './OrderDetailWrap.scss';

const OrderDetailWrap = (props) => {
  const {
    orderDetail,
    requestExchangeReturn,
    insertOrderItemCsMemoRequest,
    editOrderItemCsMemoRequest,
    getOrderItemCsInquiryList,
    getOrderItemCsInquiryListExcelDownload,
    getOrderItemCsQnaList,
    getOrderItemCsQnaListExcelDownload,
  } = props;
  const { orderInfo, cancelHistory, returnHistory, exchangeHistory, reviewInfo, balanceInfo, inquiryInfo, qnaInfo } =
    orderDetail;

  return (
    <div className="order-detail-wrap">
      {/* 주문 상세 */}
      <Tabs
        list={[
          {
            title: '주문 정보',
            content: (
              <OrderDetailInfo
                orderInfo={orderInfo}
                cancelHistory={cancelHistory[0]}
                returnHistory={returnHistory}
                exchangeHistory={exchangeHistory}
                requestExchangeReturn={requestExchangeReturn}
                insertOrderItemCsMemoRequest={insertOrderItemCsMemoRequest}
                editOrderItemCsMemoRequest={editOrderItemCsMemoRequest}
              />
            ),
          },
          {
            title: '취소 이력',
            /**
             *  취소 이력만 cancelHistory 가 배열로 넘어온다
             */
            disabled: !cancelHistory.length,
            content: <OrderCancelHistory cancelHistory={cancelHistory} />,
          },
          {
            title: '반품 이력',
            disabled: !returnHistory || !returnHistory.orderReturnHistory.length,
            content: <OrderReturnHistory returnHistory={returnHistory} />,
          },
          {
            title: '교환 이력',
            disabled: !exchangeHistory || !exchangeHistory.orderExchangeHistory.length,
            content: (
              <OrderExchangeHistory
                exchangeHistory={{
                  orderItemId: orderInfo.orderItemId,
                  recipientName: orderInfo.recipientName,
                  ...exchangeHistory,
                }}
              />
            ),
          },
          {
            title: '후기 내역',
            disabled: !reviewInfo,
            content: <ReviewDetailInfo reviewInfo={reviewInfo} />,
          },
          {
            title: '정산 내역',
            disabled: !balanceInfo,
            content: <OrderBalanceInfo balanceInfo={balanceInfo} />,
          },
          {
            title: '1:1 문의 내역 정보',
            disabled: !inquiryInfo.list.length,
            content: (
              <OrderInquiryInfo
                inquiryInfo={inquiryInfo}
                getList={getOrderItemCsInquiryList}
                getExcelDownload={getOrderItemCsInquiryListExcelDownload}
              />
            ),
          },
          {
            title: '상품 문의 내역 정보',
            disabled: !qnaInfo.list.length,
            content: (
              <OrderQnaInfo
                qnaInfo={qnaInfo}
                getList={getOrderItemCsQnaList}
                getExcelDownload={getOrderItemCsQnaListExcelDownload}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default OrderDetailWrap;
